import React, { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import config from "./config.json"; // Import the configuration JSON file
import { restTimer } from "./restTimer";
import Header, { header } from "./header";
import Footer, { footer } from "./footer";

import "./styles.css";

const renderTime = ({ remainingTime, repeats, maxRepeats, rest }) => {
  if (remainingTime === 0) {
    return (
      <div className="timer">
        {repeats === maxRepeats ? "TERMINÉ..." : "Repos..."}
      </div>
    );
  }

  return (
    <div className="timer">
      <div className="text">Temps restant</div>
      <div className="value">{remainingTime}</div>
      <div className="text">secondes</div>
      <div className="text">Repos: {rest}</div>
    </div>
  );
};

function Exercice({ name, maxRepeats, duration, rest, image, description }) {
  const [repeats, setRepeats] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isResting, setIsResting] = useState(false);
  const [isStartButtonDisabled, setIsStartButtonDisabled] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);

  console.log(
    "Rest timer previous state: ",
    rest,
    "is playing:",
    isPlaying,
    "is resting",
    isResting,
    "repeats",
    repeats
  );

  const colorsTimes = [duration - 1, 0];

  const handleStart = () => {
    setIsPlaying(true);
    setIsResting(false);
    setIsStartButtonDisabled(true);
    setIsCompleted(false)
  };

  const handleImageError = () => {
    console.error(`Failed to load image: ${image}`);
  };

  const handleScrollUp = () => {
    window.scrollTo( { left: 0, top: 0, behavior: 'smooth' } )
}


  useEffect(() => {
    if (isResting) {
      console.log("Rest timer previous state: ", rest);
      const timer = setTimeout(() => {
        setIsResting(false);
        setIsPlaying(true);
      }, rest * 1000);
      return () => clearTimeout(timer);
    }
  }, [isResting, rest]);

  return (
    <>
      <div className="exercice" style={{
          backgroundColor: isCompleted ? "#FFD700" : "white",
      }}>
        <div className="container">
          <h1 className="exercice-name">{name}</h1>
          <button
            className="Startbutton"
            onClick={handleStart}
            disabled={isStartButtonDisabled}
          >
            Start
          </button>
          <p>{description}</p>
          <div className="timer-wrapper">
            <div className="timer-container">
              <CountdownCircleTimer
                className="countdown-timer"
                id={name}
                name="timer"
                isPlaying={isPlaying && repeats < maxRepeats} // && !isResting
                size={200}
                duration={duration}
                colors={["#00FF00", "#ff0000"]}
                colorsTime={colorsTimes}
                strokeWidth={8}
                onComplete={() => {
                  if (repeats < maxRepeats) {
                    setRepeats(repeats + 1);

                    setIsResting(true); // Set isResting to true
                    
                    //setIsPlaying(false); // Pause the main timer
                    return { shouldRepeat: true, delay: rest };
                  } else {
                    //setIsResting(true);
                    setIsPlaying(false); // Stop the main timer
                    setIsCompleted(true);
                    return { shouldRepeat: false };
                    // jump to next exercice name
                  }
                }}
              >
                {({ remainingTime }) =>
                  renderTime({ remainingTime, repeats, maxRepeats, rest })
                }
              </CountdownCircleTimer>

              <div className="reps">
                <h3>
                  Reps: {repeats}/{maxRepeats}
                </h3>
              </div>
            </div>
            <img className="exercice-image"
              src={image}
              alt={name}
              onError={(e) => {
                e.target.src = "./placeholder.png";
                e.target.style.width = "200px";
                e.target.style.height = "200px";
              }}
              //style={{ width: "50%", height: "auto", padding: "10px",  }}
            />
          </div>
        </div> 
        <button name="topbutton" className="scrollUp" onClick={handleScrollUp}>☝️Haut</button>
      </div>
      
    </>
  );
}

function App() {

  return (
    <>
      <Header/>
      <div className="App">
        {config.exercices.map((exercice, index) => (
          <Exercice
            key={index}
            name={exercice.name}
            maxRepeats={exercice.maxRepeats}
            duration={exercice.duration}
            rest={exercice.rest}
            image={exercice.photo}
            description={exercice.description}
          />
        ))}
      </div>
      <Footer />
    </>
  );
}

const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);

export default App;
